var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInformationOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.20625,10v6.13125a1.125,1.125,0,0,0,.26875.8c.13125.13125.53125.13125,1.06875.13125v.4c-1.06875,0-1.875-.13125-2.53125-.13125a18.87533,18.87533,0,0,0-2.53125.13125v-.4A7.18157,7.18157,0,0,0,10.55,16.93125a1.125,1.125,0,0,0,.26875-.8v-4.8a.46248.46248,0,0,0-.13125-.26875,7.3686,7.3686,0,0,0-1.2-.13125v-.4A16.80623,16.80623,0,0,0,13.2375,10Zm.13125-2.13125a1.33125,1.33125,0,1,1-.3877-.94538A1.33125,1.33125,0,0,1,13.3375,7.86875ZM12.00625,3.33333A8.66667,8.66667,0,1,1,3.33958,12a8.66667,8.66667,0,0,1,8.66667-8.66667Zm0-1.33333a10.075,10.075,0,0,0-10,10,10.075,10.075,0,0,0,10,10,10.075,10.075,0,0,0,10-10,10.075,10.075,0,0,0-10-10Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationOutline);
export default __webpack_public_path__ + "static/media/information_outline.c96e7369e46573099e31e11123feaea9.svg";
export { ForwardRef as ReactComponent };